import { createSlice } from '@reduxjs/toolkit';

const initialMessage = [{ id: 1, text: 'Hi! How can I assist you today?', sender: 'bot' }];

const chatBotSlice = createSlice({
	name: 'chatBot',
	initialState: {
		messages: initialMessage,
		history: []
	},
	reducers: {
		updateMessages: (state, action) => {
			state.messages.push(action.payload);
		},
		resetMessages: state => {
			state.messages = initialMessage;
		},
		updateHistory: (state, action) => {
			state.history.push(action.payload);
		},
		resetHistory: state => {
			state.history = [];
		}
	}
});

export const { updateMessages, resetMessages, updateHistory, resetHistory } = chatBotSlice.actions;
export default chatBotSlice.reducer;
